import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

export default function PaymentPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Payment Policy</h1>
        <Card className="p-8 prose max-w-none text-gray-700">
          <h2 className="font-bold text-lg">How Payments Are Processed</h2>
          <p>Payments for Daily UAE Jobs digital products are processed manually and securely by <strong>Nishu4shaku Digital Marketing Agency</strong>. Customers complete payment by contacting our WhatsApp Business number.</p>

          <h2 className="font-bold text-lg mt-4">Verified Delivery</h2>
          <p>Once payment is verified, your plan entitlements (CV Optimizer, LinkedIn Tools, Cover Letter, Interview Prep, etc.) are activated on your Daily UAE Jobs account within 24 hours by our admin team.</p>

          <h2 className="font-bold text-lg mt-4">Pricing</h2>
          <ul className="list-disc pl-6">
            <li>Free — AED 0 (Basic ATS Check)</li>
            <li>Pro — AED 99 (CV Optimization or CV Builder + PDF/DOCX)</li>
            <li>Career Boost — AED 199 (Everything in Pro + LinkedIn + Cover Letter + Templates)</li>
            <li>Elite — AED 499 (60-day personalized support + 4 private calls)</li>
          </ul>

          <h2 className="font-bold text-lg mt-4">Contact</h2>
          <p>Payment questions: Admin@dailyuaejobs.com · WhatsApp +971 52 131 0804</p>

          <p className="text-xs text-gray-500 mt-6 pt-4 border-t">
            Daily UAE Jobs is a career support platform, not a recruitment agency. We do not guarantee jobs, interviews, or referrals.
          </p>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
